/**
 * 家紋ステッカー商品 カスタマイズ
 *
 * 機能:
 * - ドロップダウン検索機能（家紋名で絞り込み）
 * - 選択肢の左側に家紋画像を表示
 * - Globo Product Options 対応
 *
 * @version 1.0
 */

(function () {
  "use strict";

  // ============================================
  // 定数定義
  // ============================================
  const CONSTANTS = {
    SELECTORS: {
      BUY_BUTTONS: 'buy-buttons[template="kamon-sticker"]',
    },
    IMAGE_BASE_URL: "https://edomojiyaouan.com/cdn/shop/t/9/assets/",
  };

  // ============================================
  // ユーティリティ関数
  // ============================================
  const isKamonStickerProduct = () => {
    return document.querySelector(CONSTANTS.SELECTORS.BUY_BUTTONS) !== null;
  };

  // ============================================
  // メイン初期化
  // ============================================
  document.addEventListener("DOMContentLoaded", function () {
    // 家紋ステッカー商品かどうか判定
    if (!isKamonStickerProduct()) return;

    // ローディングオーバーレイを表示
    showLoadingOverlay();

    // ドロップダウン検索機能の初期化
    try {
      initKamonStickerDropdownSearch();
    } catch (error) {
      console.error(
        "家紋ステッカー ドロップダウン検索機能の初期化エラー:",
        error,
      );
    }

    // ローディング完了を監視
    waitForOptionsLoaded();
  });

  // ============================================
  // ローディングオーバーレイ
  // ============================================
  function showLoadingOverlay() {
    const existing = document.querySelector(".kamon-sticker-loading-overlay");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.className = "kamon-sticker-loading-overlay";
    overlay.innerHTML = `
      <div class="kamon-sticker-loading-spinner"></div>
      <div class="kamon-sticker-loading-text">読み込み中...</div>
    `;
    document.body.appendChild(overlay);
  }

  function hideLoadingOverlay() {
    const overlay = document.querySelector(".kamon-sticker-loading-overlay");
    if (overlay) {
      overlay.classList.add("hidden");
      setTimeout(() => overlay.remove(), 300);
    }
  }

  function waitForOptionsLoaded() {
    let checkCount = 0;
    const maxChecks = 50; // 最大5秒待機

    const checkInterval = setInterval(() => {
      checkCount++;

      const gpoElements = document.querySelectorAll(
        ".gpo-element, .gpo-swatches, .gpo-dropdown",
      );

      if (gpoElements.length > 0 || checkCount >= maxChecks) {
        clearInterval(checkInterval);
        setTimeout(hideLoadingOverlay, 300);
      }
    }, 100);
  }

  // ============================================
  // ドロップダウン検索機能（家紋画像付き）
  // ============================================
  function initKamonStickerDropdownSearch() {
    // 処理中フラグ（重複実行防止）
    let isProcessing = false;

    // 画像プリロード管理（同じURLは1回だけ読み込む）
    const imagePreloadMap = new Map();

    // 画像をプリロードする関数
    function preloadImage(url) {
      if (!imagePreloadMap.has(url)) {
        const img = new Image();
        img.src = url;
        imagePreloadMap.set(url, img);
      }
      return imagePreloadMap.get(url);
    }

    // すべてのドロップダウン要素を取得して検索機能を追加
    function addSearchToDropdowns() {
      if (isProcessing) return;
      isProcessing = true;

      const dropdowns = document.querySelectorAll(".gpo-dropdown");
      dropdowns.forEach((dropdown) => {
        const dropdownList = dropdown.querySelector(".dropdown-list");
        if (!dropdownList) return;

        // 既に処理済みの場合はスキップ
        if (dropdown.dataset.kamonSearchAdded === "true") return;
        dropdown.dataset.kamonSearchAdded = "true";

        // 既存の検索ボックスを削除（再作成のため）
        const existingSearch = dropdown.querySelector(
          ".kamon-dropdown-search-wrapper",
        );
        const existingNoResults = dropdown.querySelector(
          ".kamon-dropdown-no-results",
        );
        if (existingSearch) existingSearch.remove();
        if (existingNoResults) existingNoResults.remove();

        // 検索ボックスのラッパーを作成
        const searchWrapper = document.createElement("div");
        searchWrapper.className = "kamon-dropdown-search-wrapper";

        // 検索エリアのクリックでドロップダウンが閉じないようにする
        searchWrapper.addEventListener("click", (e) => e.stopPropagation());
        searchWrapper.addEventListener("mousedown", (e) => e.stopPropagation());

        // 検索入力フィールドを作成
        const searchInput = document.createElement("input");
        searchInput.type = "text";
        searchInput.className = "kamon-dropdown-search";
        searchInput.placeholder = "家紋を検索...";

        // 検索ボックスのイベント制御
        searchInput.addEventListener("click", (e) => e.stopPropagation());
        searchInput.addEventListener("mousedown", (e) => e.stopPropagation());
        searchInput.addEventListener("focus", (e) => e.stopPropagation());

        // 検索結果なしメッセージを作成
        const noResultsMessage = document.createElement("div");
        noResultsMessage.className = "kamon-dropdown-no-results";
        noResultsMessage.textContent = "該当する家紋が見つかりません";

        searchWrapper.appendChild(searchInput);

        // ドロップダウンリストの最初に検索ボックスを挿入
        dropdownList.insertBefore(searchWrapper, dropdownList.firstChild);
        dropdownList.appendChild(noResultsMessage);

        // すべてのドロップダウン項目を取得
        const items = dropdown.querySelectorAll(
          'input[type="radio"], input[type="checkbox"]',
        );

        // 画像をバッチ処理で追加
        const BATCH_SIZE = 50;
        const addImagesInBatches = (startIndex) => {
          const endIndex = Math.min(startIndex + BATCH_SIZE, items.length);

          for (let i = startIndex; i < endIndex; i++) {
            const item = items[i];
            const label = item.nextElementSibling;
            if (!label) continue;

            // 既存の画像要素をチェック
            if (label.querySelector(".kamon-dropdown-item-image")) continue;

            // ラベルのテキストからファイル名を生成
            const labelText = label.textContent.trim();
            // テキストから価格などを除去してファイル名を取得
            const cleanText = labelText.split(/[(\uff08]/)[0].trim();

            // 画像URLを取得
            let imageUrl = "";

            // kamon-map.js の kamonMap を使用
            if (typeof kamonMap !== "undefined" && kamonMap[cleanText]) {
              imageUrl = `${CONSTANTS.IMAGE_BASE_URL}${kamonMap[cleanText]}`;
            } else {
              // マッピングがない場合は元のテキストを使用
              const encodedFileName = encodeURIComponent(cleanText);
              imageUrl = `${CONSTANTS.IMAGE_BASE_URL}${encodedFileName}.png`;
            }

            // 画像をプリロード
            preloadImage(imageUrl);

            // 画像要素を作成
            const imgElement = document.createElement("img");
            imgElement.className = "kamon-dropdown-item-image";
            imgElement.alt = cleanText;
            imgElement.loading = "lazy";
            imgElement.src = imageUrl;

            // エラー時の処理
            imgElement.onerror = function () {
              this.style.display = "none";
            };

            // ラベルの最初に画像を挿入
            label.insertBefore(imgElement, label.firstChild);
          }

          // 次のバッチを処理
          if (endIndex < items.length) {
            setTimeout(() => addImagesInBatches(endIndex), 100);
          }
        };

        // 画像追加を開始
        if (items.length > 0) {
          addImagesInBatches(0);
        }

        // 検索機能の実装
        searchInput.addEventListener("input", function () {
          const searchTerm = this.value.toLowerCase().trim();
          let visibleCount = 0;

          items.forEach((item) => {
            const label = item.nextElementSibling;
            if (!label) return;

            const text = label.textContent.toLowerCase();
            const isMatch = text.includes(searchTerm);

            const dropdownItem = item.closest(".dropdown-item");

            if (isMatch) {
              item.setAttribute("data-hidden", "false");
              if (dropdownItem) {
                dropdownItem.style.display = "";
              } else {
                label.style.display = "";
              }
              visibleCount++;
            } else {
              item.setAttribute("data-hidden", "true");
              if (dropdownItem) {
                dropdownItem.style.display = "none";
              } else {
                label.style.display = "none";
              }
            }
          });

          // 検索結果がない場合のメッセージ表示
          noResultsMessage.style.display =
            visibleCount === 0 ? "block" : "none";
        });

        // ドロップダウンが開かれた時に検索ボックスにフォーカス
        const dropdownButton = dropdown.querySelector(".dropdown-button");
        if (dropdownButton) {
          dropdownButton.addEventListener("click", function () {
            setTimeout(() => {
              const isOpen =
                dropdown.classList.contains("active") ||
                dropdownList.style.display !== "none";
              if (isOpen) {
                // 検索をリセット
                searchInput.value = "";
                items.forEach((item) => {
                  item.setAttribute("data-hidden", "false");
                  const dropdownItem = item.closest(".dropdown-item");
                  if (dropdownItem) {
                    dropdownItem.style.display = "";
                  } else {
                    const label = item.nextElementSibling;
                    if (label) label.style.display = "";
                  }
                });
                noResultsMessage.style.display = "none";
                searchInput.focus();
              }
            }, 150);
          });
        }

        // ============================================
        // 家紋プレビュー機能
        // ============================================
        // プレビューエリアを作成
        const previewArea = document.createElement("div");
        previewArea.className = "kamon-preview-area";
        previewArea.innerHTML = `
          <div class="kamon-preview-inner">
            <img class="kamon-preview-image" src="" alt="" />
            <div class="kamon-preview-name"></div>
          </div>
          <div class="kamon-preview-note">※画像はイメージです。</div>
        `;
        previewArea.style.display = "none";

        // プレビューエリアをドロップダウンの親要素の後に挿入
        const gpoElement = dropdown.closest(".gpo-element");
        if (gpoElement) {
          gpoElement.appendChild(previewArea);
        } else {
          dropdown.parentNode.insertBefore(previewArea, dropdown.nextSibling);
        }

        // プレビューを更新する関数
        function updateKamonPreview(kamonName) {
          if (!kamonName) {
            previewArea.style.display = "none";
            return;
          }

          const cleanText = kamonName.split(/[(\uff08]/)[0].trim();
          let imageUrl = "";

          if (typeof kamonMap !== "undefined" && kamonMap[cleanText]) {
            imageUrl = `${CONSTANTS.IMAGE_BASE_URL}${kamonMap[cleanText]}`;
          } else {
            const encodedFileName = encodeURIComponent(cleanText);
            imageUrl = `${CONSTANTS.IMAGE_BASE_URL}${encodedFileName}.png`;
          }

          const previewImage = previewArea.querySelector(
            ".kamon-preview-image",
          );
          const previewName = previewArea.querySelector(".kamon-preview-name");

          previewImage.src = imageUrl;
          previewImage.alt = cleanText;
          previewName.textContent = cleanText;
          previewArea.style.display = "block";

          previewImage.onerror = function () {
            previewArea.style.display = "none";
          };
        }

        // 選択変更を監視
        items.forEach((item) => {
          item.addEventListener("change", function () {
            if (this.checked) {
              const label = this.nextElementSibling;
              if (label) {
                const labelText = label.textContent.trim();
                updateKamonPreview(labelText);
              }
            }
          });
        });

        // 初期状態で選択済みの家紋があればプレビューを表示
        const checkedItem = dropdown.querySelector(
          'input[type="radio"]:checked, input[type="checkbox"]:checked',
        );
        if (checkedItem) {
          const label = checkedItem.nextElementSibling;
          if (label) {
            updateKamonPreview(label.textContent.trim());
          }
        }
      });

      isProcessing = false;
    }

    // 初回実行
    setTimeout(() => {
      addSearchToDropdowns();
    }, 1000);

    // デバウンスタイマー
    let dropdownObserverDebounceTimer = null;

    // MutationObserverで動的に追加されるドロップダウンを監視
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // 自身が追加した要素はスキップ（無限ループ防止）
              if (
                node.classList &&
                (node.classList.contains("kamon-dropdown-item-image") ||
                  node.classList.contains("kamon-dropdown-search-wrapper") ||
                  node.classList.contains("kamon-dropdown-no-results"))
              ) {
                return;
              }

              if (
                node.classList?.contains("gpo-dropdown") ||
                node.querySelector?.(".gpo-dropdown") ||
                node.classList?.contains("dropdown-list")
              ) {
                shouldUpdate = true;
              }
            }
          });
        }
      });

      if (shouldUpdate) {
        if (dropdownObserverDebounceTimer) {
          clearTimeout(dropdownObserverDebounceTimer);
        }
        dropdownObserverDebounceTimer = setTimeout(() => {
          addSearchToDropdowns();
          dropdownObserverDebounceTimer = null;
        }, 400);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
